<template>
    <div id="slider" :class="collapsed?'logo-collapse-width':'logo-width'">
        <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
            <!--导航菜单-->
            <el-menu :default-active="this.$route.path" unique-opened :default-openeds="['2']" ref="menuUnCollapsed" class=""
                     @open="handleopen" @close="handleclose"
                     @select="handleselect"
                     v-show="!collapsed">
                <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                    <el-submenu :index="index+''" class="" v-if="!item.leaf">
                        <template slot="title"><i :class="item.iconCls"></i>{{item.meta.title}}</template>
                        <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path"
                                      v-if="!child.hidden" @click="$router.push(child.path)">{{child.meta.title}}
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i
                            :class="item.iconCls"></i>{{item.children[0].meta.title}}
                    </el-menu-item>
                </template>
            </el-menu>

            <!--导航菜单-折叠后-->
            <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
                <li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
                    <template v-if="!item.leaf">
                        <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)"
                             @mouseout="showMenu(index,false)"><i :class="item.iconCls" style="margin-right:6px;"></i>
                        </div>
                        <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)"
                            @mouseout="showMenu(index,false)">
                            <li v-for="child in item.children" v-if="!child.hidden" :key="child.path"
                                class="el-menu-item" style="padding-left: 40px;"
                                :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">
                                {{child.meta.title}}
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                <li class="el-submenu">
                    <div class="el-submenu__title el-menu-item"
                         style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                         :class="$route.path==item.children[0].path?'is-active':''"
                         @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
                </li>
</template>
</li>
</ul>
</aside>
</div>
</template>

<script>

    export default {
        name: "sliderbar",
        data() {
            return {
                collapsed: this.$store.state.sysAdmin.collapsed,
            }
        },
        methods: {
            handleopen() {
                //console.log('handleopen');
            },
            handleclose() {
                //console.log('handleclose');
            },
            handleselect: function (a, b) {
            },
            showMenu(i, status) {
                this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
            },
        },
        mounted() {

        },
        watch: {
            '$store.state.sysAdmin.collapsed'(to, from) {
                this.collapsed = to
                if (to) {
                    this.$refs.menuCollapsed.getElementsByTagName("ul")[0].style.display = 'none'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .logo {
        height: 60px;
        font-size: 22px;
        padding-left: 20px;
        padding-right: 20px;
        border-color: rgba(238, 241, 146, 0.3);
        border-right-width: 1px;
        border-right-style: solid;

        img {
            width: 40px;
            float: left;
            margin: 10px 10px 10px 18px;
        }

        .txt {
            color: #fff;
        }
    }

    .logo-width {
        width: 169px;
    }

    #slider {
        height: 100%;
        background: rgb(238, 246, 246);
    }
</style>



// WEBPACK FOOTER //
// Sliderbar.vue?5e0e1dac